const INFO = 0;
const WARNING = 1;
const ERROR = 2;
const SUCCESS = 3;

export const notificationCodes = { INFO, WARNING, ERROR, SUCCESS };
